import { createAction, props } from '@ngrx/store';

export const logoLoadedFromStore = createAction(
	'[Railroads] Logo Loaded From Store',
	props<{ logo: string }>()
);

export const logoLoadedFromApi = createAction(
	'[Railroads] Logo Loaded From Api',
	props<{ logo: string }>()
);

export const logoUploaded = createAction(
	'[Railroads] Logo Uploaded',
	props<{ event: { target: HTMLInputElement } }>()
);

export const logoSuccessfullyBuffered = createAction(
	'[Railroads] Logo Successfully Buffered',
	props<{ logo: string }>()
);

export const logoSuccessfullyUploadedToApi = createAction(
	'[Railroads] Logo Successfully Uploaded To Api'
);

export const userClickedRemoveLogo = createAction(
	'[Railroads] User Clicked Remove Logo'
);

export const logoRemoved = createAction('[Railroads] Logo Removed');
